<template>
  <div class="produitn1 needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" title="produitn1.title" :text="info.infoKey" ></Info>
    <div class="produitn1-title">
      <h3>{{$t('produitn1.title')}}</h3>
      <h2>{{$t('produitn1.description')}}</h2>
    </div>
    <div class="table-container">
      <div class="table">
        <div class="row header">
          <div class="cell header">
            {{$t('rank')}}
          </div>
          <div class="cell header">
            {{$t('brands')}}
          </div>
          <div class="cell header">
            {{$t('articles')}}
          </div>
          <div class="cell header">
            {{$t('percentage')}}
          </div>
        </div>
        <div class="row" v-for="(product, index) in getItems">
          <div class="cell rang" data-title="RANG">
            {{index + 1}}
          </div>
          <div class="cell" data-title="MARQUES">
            {{product.label}}
          </div>
          <div class="cell" data-title="ARTICLES">
            {{product.quantities.value | getKNumber | splitNumber}}
          </div>
          <div class="cell" data-title="POURCENTAGES">
            {{product.percentage}}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Produitn1',
    components: {
      Info
    },
    props: {
      result: Object,
      search: Object
    },
    data() {
      return {
        fullscreen: false,
        info: {
         infoKey: this.getInfoKey()
        },
      }
    },
    computed: {
      getItems() {
        if (this.result && this.result.aggregations && this.result.aggregations['to-bills'] && this.result.aggregations['to-bills'].bills && this.result.aggregations['to-bills'].bills.details && this.result.aggregations['to-bills'].bills.details['filtered-results'] && this.result.aggregations['to-bills'].bills.details['filtered-results']['cd_GrpLevel1']) {
          return this.result.aggregations['to-bills'].bills.details['filtered-results']['cd_GrpLevel1'].buckets
        }
        return []
      }
    },
    mounted() {
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      },
      getInfoKey() {
        let brand = this.search.query.businessUnit.substring(0,3);
        if (brand === 'MID') {
          return "produitn1.midasInfo";
        } else {
          return "produitn1.norautoAtuInfo";
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/produitn1.sass"
</style>
